<template>
  <div class="content">
    <div class="title">WAITING...</div>
    <div class="msg">Reload soon, if no response please click the button below</div>
    <div class="msg">即将重新载入,如无反应请点击下面的按钮</div>
    <el-button plain @click="goback">back</el-button>
  </div>
</template>
<script>
export default {
  methods: {
    goback() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="scss">
.content{
  margin: 100px;
  .title{
    font-size: 40px;
    font-weight: 700;
    color: #fff
  }
  .msg{
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #fff;
  }
}
</style>

